import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showSummary: false,
    summary: null,
    loading: false,
};

const campaignSummarySlice = createSlice({
    name: 'CampaignSummary',
    initialState,
    reducers: {
        showSummaryAction: (state, action) => {
            state.showSummary = true;
            if (action.payload) {
                state.summary = action.payload
            }
        },
        hideSummaryAction: (state) => {
            state.showSummary = false;
        },
        getSummary: (state) => {
            state.loading = true;
        },
        setSummary: (state, action) => {
            state.summary = action.payload;
            state.loading = false;
        },
        getSummaryError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    },
});

export const {
    showSummaryAction,
    hideSummaryAction,
    getSummary,
    setSummary,
    getSummaryError
} = campaignSummarySlice.actions;

export default campaignSummarySlice.reducer;
